import React from 'react';
import { formatMinistryMonthLabel } from '../../utils/mbcbReportPeriodLabels';
import type { SundayKey, WorshipWeeklyState } from '../../utils/mbcbReportShared';
import { NumberStepper } from './NumberStepper';
import { SundayGrid } from './SundayGrid';
import { NarrativeField } from './EditorShell';

interface StepNumbersProps {
  ministryMonth: number;
  ministryYear: number;
  weekly: WorshipWeeklyState;
  setSunday: (sk: SundayKey, value: string) => void;
  newMembers: number;
  setNewMembers: (n: number) => void;
  baptisms: number;
  setBaptisms: (n: number) => void;
  salvations: number;
  setSalvations: (n: number) => void;
  attendanceNotes: string;
  setAttendanceNotes: (v: string) => void;
  canEdit: boolean;
  onFieldChange?: () => void;
}

export const StepNumbers: React.FC<StepNumbersProps> = ({
  ministryMonth,
  ministryYear,
  weekly,
  setSunday,
  newMembers,
  setNewMembers,
  baptisms,
  setBaptisms,
  salvations,
  setSalvations,
  attendanceNotes,
  setAttendanceNotes,
  canEdit,
  onFieldChange,
}) => {
  const ministryLabel = formatMinistryMonthLabel(ministryMonth, ministryYear);

  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-4 py-5 space-y-5 animate-step-in">
      <div className="rounded-2xl bg-white border border-gray-100 px-4 py-4 shadow-sm">
        <h2 className="text-lg font-bold text-gray-900">Attendance &amp; counts</h2>
        <p className="text-sm text-gray-600 mt-1">
          Worship headcount for each Sunday in {ministryLabel}.
        </p>
      </div>

      <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm space-y-3">
        <h3 className="text-sm font-semibold text-gray-900">Worship by Sunday</h3>
        <SundayGrid
          weekly={weekly}
          onChange={(sk, v) => {
            setSunday(sk, v);
            onFieldChange?.();
          }}
          disabled={!canEdit}
        />
      </div>

      <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">Life-change this month</h3>
        <div className="grid grid-cols-3 gap-2">
          <NumberStepper
            label="New members"
            value={newMembers}
            onChange={(n) => {
              setNewMembers(n);
              onFieldChange?.();
            }}
            disabled={!canEdit}
          />
          <NumberStepper
            label="Baptisms"
            value={baptisms}
            onChange={(n) => {
              setBaptisms(n);
              onFieldChange?.();
            }}
            disabled={!canEdit}
          />
          <NumberStepper
            label="Faith decisions"
            value={salvations}
            onChange={(n) => {
              setSalvations(n);
              onFieldChange?.();
            }}
            disabled={!canEdit}
          />
        </div>
      </div>

      <NarrativeField
        label="Attendance notes (optional)"
        hint="Explain a zero week, holiday, or anything unusual."
        value={attendanceNotes}
        onChange={(v) => {
          setAttendanceNotes(v);
          onFieldChange?.();
        }}
        disabled={!canEdit}
        rows={2}
      />
    </div>
  );
};
